<template>
  <div>
    <div class="page page__list">
      <search-bar
        @search="onSearch"
        name="sa_code"
        placeholder="输入单据编号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/quality/qcsample/' + item.id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.sa_code }}</p>
            <p class="list-item-muted">{{ item.sa_name }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>默认-{{ item.sa_default ? '是' :'否' }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.sa_status != '已审核' }"
              >{{ item.sa_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}笔</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/qcsample/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            }
          ],
        },
      ],
    };
  }
};
</script>